import React, { useState } from 'react'
import SnackbarToast from '../../components/toasts/SnackbarToast'
import DeleteModal from '../../components/modals/DeleteModal'
import { DropdownItem, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
// import UpdateEbookPage from './UpdateEbookPage'
import { Delete, Edit, MoreVert } from '@material-ui/icons'
import { Dropdown } from 'react-bootstrap'
import axios from 'axios'
import ENDPOINT from '../../context/EndPoint'
import SecurityHeaders from '../../context/SecurityHeaders'
import { useDispatch } from 'react-redux'
import { FaEye, FaEdit } from "react-icons/fa";

const EbookItem = ({ item, reload }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState({
    open: false,
    message: '',
    type: ''

  });
  const [modelShow, setModelShow] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [formData, setFormData] = useState({
    book_name: item.book_name,
    description: item.description,
    course_url: item.course_url,
    batch_id: item.batch_id,
    cover_url: item.cover_url,
    title: item.title,
  });

  const [message, setMessage] = useState(""); // To store API response

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({type:'LOADING'})

    if (!formData.cover_url) {
      setMessage("Please select an image.");
      return;
    }

    const data = new FormData();
    data.append("book_name", formData.book_name);
    data.append("title", formData.title);
    data.append("book_id", item.book_id);
    data.append("description", formData.description);
    data.append("course_url", formData.course_url);
    data.append("batch_id", formData.batch_id);
    data.append("cover_url", formData.cover_url);

    try {
      const response = await axios.post(ENDPOINT +
        "update-book.php",
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if(response.data.status === "success"){
        dispatch({type:'DONE_LOADING'})
        setMessage("Ebook updated successfully.");
        setOpen((pre) => ({...pre, open: true, type: "success" ,message: "Ebook updated successfully"}));
        setModelShow(false)
        reload(true);
      }
      else{
        setMessage("Error updating eBook.");
      dispatch({type:'ERROR', payload:'Error occurred while updating'})
      }
    } catch (error) {
      setMessage("Error uploading eBook.");
      dispatch({type:'ERROR', payload:error.message})
    }
  };
  const deleteBook = async () => {
    dispatch({type:'LOADING'})
    const data = new FormData();
    data.append('book_id', item.book_id);
    try {
      
        const response = await axios.post(ENDPOINT + "delete-book.php", data, SecurityHeaders)
        if (response.data.status === "success") {
            setOpen({ open: true, message: "Book deleted successfully", type: "success" });
            dispatch({type:'DONE_LOADING'})
            reload();
            setDeleteConfirmation(false);
        }
        else {
            dispatch({payload: response.data.message, type: "danger" });
        }
    }
    catch (err) {
        console.error(err);
        dispatch({ payload: "Failed to delete Book", type: 'ERROR' });
    }
}

  return (
    <>
      <SnackbarToast open={open} handleClose={() => setOpen((pre) => ({ ...pre, open: false }))} />

      <DeleteModal show={deleteConfirmation} HandleClose={() => setDeleteConfirmation(false)} HandleDelete={deleteBook} />

     <Modal show={modelShow} onHide={() => setModelShow(false)} centered size="lg">
  <Modal.Header closeButton className="border-0">
    <div>
      <h5 className="mb-0 fw-semibold">Update eBook</h5>
      <small className="text-muted">
        Modify ebook details and save changes
      </small>
    </div>
  </Modal.Header>

  <Modal.Body className="pt-0">
    {message && (
      <div className="alert alert-info rounded-3 py-2">
        {message}
      </div>
    )}

    <form onSubmit={handleSubmit} encType="multipart/form-data">
      <div className="row g-4">

        {/* Book Name */}
        <div className="col-md-6">
          <label className="form-label fw-medium small">
            Book Name
          </label>
          <input
            type="text"
            className="form-control rounded-3"
            name="book_name"
            value={formData.book_name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Title */}
        <div className="col-md-6">
          <label className="form-label fw-medium small">
            Title
          </label>
          <input
            type="text"
            className="form-control rounded-3"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        {/* Description */}
        <div className="col-12">
          <label className="form-label fw-medium small">
            Description
          </label>
          <textarea
            rows="4"
            className="form-control rounded-3"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>

        {/* Course URL */}
        <div className="col-md-6">
          <label className="form-label fw-medium small">
            Course URL
          </label>
          <input
            type="url"
            className="form-control rounded-3"
            name="course_url"
            value={formData.course_url}
            onChange={handleChange}
            required
          />
        </div>

        {/* Batch ID */}
        <div className="col-md-3">
          <label className="form-label fw-medium small">
            Batch ID
          </label>
          <input
            type="number"
            className="form-control rounded-3"
            name="batch_id"
            value={formData.batch_id}
            onChange={handleChange}
            required
          />
        </div>

        {/* Image URL */}
        <div className="col-md-3">
          <label className="form-label fw-medium small">
            Cover Image URL
          </label>
          <input
            type="url"
            className="form-control rounded-3"
            name="cover_url"
            onChange={handleChange}
            required
          />
        </div>

        {/* Actions */}
        <div className="col-12 d-flex justify-content-end gap-2 pt-3">
          <button
            type="button"
            className="btn btn-light px-4"
            onClick={() => setModelShow(false)}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary px-4">
            Save Changes
          </button>
        </div>

      </div>
    </form>
  </Modal.Body>
</Modal>

     <div className="col-lg-4 col-md-6 p-3">
  <div className="bg-white rounded-4 h-100 shadow-sm position-relative">

    {/* Actions (Hidden) */}
    <Dropdown className="position-absolute top-0 end-0 m-2">
      <Dropdown.Toggle className="btn btn-light btn-sm rounded-circle">
        <MoreVert fontSize="small" />
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        <Dropdown.Item onClick={() => setModelShow(true)}>
          <Edit fontSize="small" className="me-2" />
          Update
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => setDeleteConfirmation(true)}
          className="text-danger"
        >
          <Delete fontSize="small" className="me-2" />
          Delete
        </Dropdown.Item>
       {/* <DropdownItem className="d-flex align-items-center gap-2">
<FaEye size={14} />
<span>View invoice</span>
</DropdownItem> */}


{/* <DropdownItem className="d-flex align-items-center gap-2">
<FaEdit size={14} />
<span>Edit invoice</span>
</DropdownItem> */}
      </Dropdown.Menu>
    </Dropdown>

    {/* Cover */}
    <img
      src={
        item.cover_url ||
        "https://siliconmindstechnologies.com/assets/img/hacking.jpg"
      }
      className="w-100 rounded-top-4"
      style={{ height: "190px", objectFit: "cover" }}
      alt="ebook"
    />

    {/* Content */}
    <div className="p-3">
      <h6 className="fw-semibold mb-1 text-truncate">
        {item.book_name}
      </h6>

      <p className="small text-muted mb-2">
        Batch ID • {item.batch_id}
      </p>

      <p className="small text-muted mb-3 line-clamp-2">
        {item.description}
      </p>

      <a
        href={item.course_url}
        target="_blank"
        rel="noreferrer"
        className="small text-decoration-none fw-medium"
      >
        View Course →
      </a>
    </div>

    {/* Primary CTA */}
    <div className="px-3 pb-3">
      <Link
        to={`/book/${item.book_name}/${item.book_id}`}
        className="btn btn-primary w-100 rounded-3"
      >
        Read Book
      </Link>
    </div>

  </div>
</div>


    </>
  )
}

export default EbookItem

